//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueBarcode from "vue-barcode";
import { mapActions } from "vuex";
import VueQrcode from "vue-qrcode";
export default {
  components: {
    barcode: VueBarcode,
    VueQrcode,
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 15, // current rows per page being displayed
        sortBy: "ProductNumber",
        descending: false,
      },
      barcodeValue: "A0101",
      toggleProductEAN: null,
      productEAN: [],
      locationEAN: [],
      selectedLocations: [],
      toggleLabel: "Velg mellom strekkode eller produktnummer",
      selectedProducts: [],
      hideTableBottom: true,
      columnsProductEAN: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: "productNumber",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: "productName",
          sortable: true,
        },
        {
          name: "ean",
          align: "left",
          label: "Strekkode",
          field: "ean",
          sortable: true,
        },
      ],

      columnsLocationEAN: [
        {
          name: "locationName",
          align: "left",
          label: "Lokasjonsnavn",
          field: "locationName",
          sortable: true,
        },
        {
          name: "warehouseName",
          align: "left",
          label: "Varehus",
          field: "warehouseName",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions("main", ["getBarcodes", "getLocation"]),
    printLocations() {
      var divContents = document.getElementById("cfg").innerHTML;
      var a = window.open("", "", "height=500, width=500");
      a.document.write("<html>");
      a.document.write("<body >");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.write(
        "<style type='text/css' media='print'> @page {size: auto;margin: 0mm;}</style>"
      );

      a.document.close();
      a.print();
    },

    printProductEans() {
      var divContents = document.getElementById("cfm").innerHTML;
      var a = window.open("", "", "height=500, width=500");
      a.document.write("<html>");
      a.document.write("<body >");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.write(
        "<style type='text/css' media='print'> @page {size: auto;margin: 0mm;}</style>"
      );

      a.document.close();
      a.print();
    },
  },
  watch: {
    toggleProductEAN(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue === true) {
          this.toggleLabel = "Produktnummer";
        } else {
          this.toggleLabel = "Strekkode";
        }
      }
    },
  },
  async created() {
    this.productEAN = await this.getBarcodes();
    this.locationEAN = await this.getLocation();
  },
};
